import { ChangeDetectionStrategy, Component, HostBinding, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { ScrollerComponent } from '@blaze-shared/shared-ui';

@Component({
  selector: 'blaze-table-popup-menu',
  templateUrl: './table-popup-menu.component.html',
  styleUrls: ['./table-popup-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, ScrollerComponent],
})
export class TablePopupMenuComponent {
  closePanel = output<void>();

  @HostBinding('attr.tabindex')
  tabIndex = 0;
}
